module.exports = "mat-card{\n  width: 100%;\n}\n\n#listWidth{\n  width: 50%;\n}\n\n#button{\n  alignment: center;\n}\n"